import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Autocomplete } from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import ToggleButton from "@mui/material/ToggleButton";
import TextField from "@material-ui/core/TextField";
import SaveButton from "../../givBee/buttons/SaveButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Button from "@material-ui/core/Button";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Utils from "../../../provider/Utils";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import store from "../../../redux/store";
import AdminMenuWithBreadScrum from "../adminMenu/AdminMenuWithBreadScrum";
import PtsAlert from "../../givBee/ptsAlert/PtsAlert";
import CreateButton from "../../givBee/buttons/CreateButton";
import CancelIconButton from "../../givBee/buttons/CancelIconButton";
import {
  ApAppuserCreate_Url,
  ApAppuserDelete_Url,
  ApAppuserGet_Url,
  ApAppuserUpdate_Url,
} from "../../../provider/ServiceUrl";
import InfoTooltip from "../../givBee/infoTooltip/InfoTooltip";

class AdminAppUser extends Component {
  header = store.getState().adminHeader.adminHeader;
  appUserRoleList = store.getState().appUserRole.appUserRoleList;
  title = "Admin User Details";
  breadCrumb = [
    { pageid: "/appUserList", uiname: "Admin User List" },
    { pageid: "", uiname: "Admin User" },
  ];
  constructor(props) {
    super(props);
    let action = props.action;
    let appUserId = props.appUserId;
    if (!action && props.state) {
      action = props.state.action;
      appUserId = props.state.appUserId;
    }

    if (null !== appUserId && appUserId > 0) {
      this.getUserDetails(appUserId);
    }

    this.state = {
      action: action,
      appUserId: appUserId,
      firstName: "",
      lastName: "",
      email: "",
      countryCode: "+1",
      phoneNo: "",
      phone: "",
      password: "",
      confirmPassword: "",
      userStatus: {},
      appUserRole: null,
      showPassword: false,
      showConfirmPassword: false,
      isStatus: true,
      render: false,
      getUpdatePermission: false,
      getDeletePermission: false,
      sendOtpByEmail: false,
      sendOtpByText: false,
    };
  }
  getUserDetails(appUserId) {
    const postObject = {
      header: this.header,
      appuser: {
        id: appUserId,
      },
    };
    AdminFetchServerData.callPostService(ApAppuserGet_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let userDetails = output.data.appuser;
          let getPermission = Utils.getRolePermission(
            output.data.privilegeList
          );
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];
          let userStatus =
            userDetails?.userStatus?.status === "Active" &&
            userDetails?.userStatus?.status !== null;
          let phoneNo =
            userDetails?.phone !== null
              ? Utils.phoneNumberFormate(userDetails?.phone)
              : "";
          this.setState({
            render: true,
            id: userDetails.id,
            firstName: userDetails.firstName,
            lastName: userDetails.lastName,
            email: userDetails.email,
            phone: userDetails.phone,
            phoneNo: phoneNo,
            countryCode: userDetails.phoneCountrycode,
            isStatus: userStatus,
            userStatus: userDetails.userStatus,
            appUserRole: userDetails.profile,
            sendOtpByEmail: userDetails.sendOtpByEmail,
            sendOtpByText: userDetails.sendOtpByText,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
          });
        }
      })
      .catch((error) => { });
  }

  handlePasswordChange(e) {
    this.setState({ password: e.target.value });
  }
  handlePasswordConfirmChange(e) {
    this.setState({ confirmPassword: e.target.value });
  }
  handleFirstNameChange(e) {
    this.setState({ firstName: e.target.value });
  }
  handleLastNameChange(e) {
    this.setState({ lastName: e.target.value });
  }
  handleEmailChange(e) {
    this.setState({ email: e.target.value });
  }
  handleClickShowPassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }
  handleClickShowConfirmPassword() {
    this.setState({ showConfirmPassword: !this.state.showConfirmPassword });
  }

  handleUserRoleChange(selectedValue) {
    this.setState({ appUserRole: selectedValue });
  }

  // handlePhoneChange(e) {
  //   let res = e.target.value;
  //   if (res.length <= 10) {
  //     this.setState({ phone: res });
  //   }
  // }

  handleCountryChange(phone, country, e, formattedValue) {
    this.setState({
      countryCode: formattedValue,
    });
  }
  handlePhoneChange(e) {
    let val = e.target.value;
    if (val.length <= 12) {
      let value = Utils.phoneNumberFormate(val);
      this.setState({
        phoneNo: value,
        phone: e.target.value.replaceAll(/\D/g, ""),
      });
    }
  }

  handleStatusChange(e) {
    this.setState({ isStatus: !this.state.isStatus });
  }

  handleSendOtpByEmailChange(e) {
    this.setState({ sendOtpByEmail: e.target.checked, error: false });
  }
  handleSendOtpByTextChange(e) {
    this.setState({ sendOtpByText: e.target.checked, error: false });
  }

  createUserToBackend() {
    if (this.state.password !== this.state.confirmPassword) {
      return;
    }
    const postObject = {
      header: this.header,
      appuser: {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        email: this.state.email,
        phone: this.state.phone,
        phoneCountrycode: this.state.countryCode,
        credential: this.state.password,
        sendOtpByEmail: this.state.sendOtpByEmail,
        sendOtpByText: this.state.sendOtpByText,
        profile: {
          name: this.state.appUserRole.name,
          id: this.state.appUserRole.id,
        },
      },
    };
    AdminFetchServerData.callPostService(ApAppuserCreate_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let userData = output.data.appuser;
          this.getUserDetails(userData.id);
          this.setState({
            action: "view",
          });
        }
      }
    );
  }

  createCancel() {
    this.props.navigate("/appUserList");
  }

  editCancel() {
    this.setState({ action: "view", appUserId: this.state.id });
  }
  viewCancel() {
    this.props.navigate("/appUserList");
  }

  editAppUserDetails() {
    this.setState({ action: "edit", appUserId: this.state.id });
  }

  updateUserToBackend() {
    let userStatus;
    if (this.state.isStatus === true) {
      userStatus = "Active";
    } else {
      userStatus = "InActive";
    }
    const postObject = {
      header: this.header,
      appuser: {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        email: this.state.email,
        phoneCountrycode: this.state.countryCode,
        phone: this.state.phone,
        id: this.state.id,
        sendOtpByEmail: this.state.sendOtpByEmail,
        sendOtpByText: this.state.sendOtpByText,
        profile: {
          id: this.state.appUserRole.id,
        },

        userStatus: {
          status: userStatus,
        },
      },
    };
    AdminFetchServerData.callPostService(ApAppuserUpdate_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let userData = output.data.appuser;
          this.getUserDetails(userData.id);
          this.setState({
            action: "view",
          });
        }
      }
    );
  }

  deleteAppUserDetails() {
    const postObject = {
      header: this.header,
      appuser: {
        id: this.state.id,
      },
    };

    AdminFetchServerData.callPostService(ApAppuserDelete_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.props.navigate("/appUserList");
        }
      })
      .catch((error) => { });
  }

  render() {
    if (this.state.action === "create") {
      return this.createUser();
    } else if (this.state.action === "edit") {
      return this.editUser();
    } else if (this.state.action === "view") {
      return this.viewUser();
    }
  }
  createUser() {
    const error = this.state.password !== this.state.confirmPassword;
    return (
      <>
        <AdminMenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          history={this.props.history}
          name={this.title}
        />
        <div className="row">
          <ValidatorForm
            className="text-start"
            ref="form"
            onSubmit={this.createUserToBackend.bind(this)}
          >
            <div className="row" style={{ marginTop: "1em" }}>
              <div className="col-md-12">
                <div className="card" id="organizationFormCard">
                  <div className="card-body">
                    <div className="row p-2">
                      <div className="col-md-6">
                        <div className="row mt-3">
                          <label
                            className="col-sm-4 col-form-label"
                            htmlFor="collapsible-firstname"
                          >
                            First Name
                          </label>
                          <div className="col-sm-6" id="assetFormLabel">
                            <input
                              title=""
                              required
                              type="text"
                              autoComplete="off"
                              autoFocus={true}
                              id="multiStepsFirstName"
                              name="multiStepsFirstName"
                              className="form-control"
                              value={this.state.firstName}
                              onChange={this.handleFirstNameChange.bind(this)}
                              validators={["required"]}
                              errormessages={["This field is required"]}
                            />
                          </div>
                        </div>
                        <div className="row mt-3">
                          <label
                            className="col-sm-4 col-form-label"
                            htmlFor="collapsible-firstname"
                          >
                            Last Name
                          </label>
                          <div className="col-sm-6" id="assetFormLabel">
                            <input
                              title=""
                              required
                              type="text"
                              autoComplete="off"
                              id="multiStepsFirstName"
                              name="multiStepsFirstName"
                              className="form-control"
                              value={this.state.lastName}
                              onChange={this.handleLastNameChange.bind(this)}
                              validators={["required"]}
                              errormessages={["This field is required"]}
                            />
                          </div>
                        </div>
                        <div className="row mt-3">
                          <label
                            className="col-sm-4 col-form-label"
                            htmlFor="collapsible-firstname"
                          >
                            Email
                          </label>
                          <div className="col-sm-6" id="assetFormLabel">
                            <input
                              title=""
                              required
                              type="email"
                              autoComplete="off"
                              id="multiStepsFirstName"
                              name="multiStepsFirstName"
                              className="form-control"
                              value={this.state.email}
                              onChange={this.handleEmailChange.bind(this)}
                              validators={["required"]}
                              errormessages={[
                                "This field is required",
                                "Email id is not valid",
                              ]}
                            />
                          </div>
                        </div>
                        <div className="row mt-3">
                          <label
                            className="col-sm-4 form-label MuiAutocomplete-label"
                            htmlFor="collapsible-firstname"
                          >
                            Admin User Profile
                            <InfoTooltip
                              data="User Profile are created by Admin Users in Settings"
                              style={{
                                float: "right",
                              }}
                            />
                          </label>
                          <div className="col-sm-6" id="assetFormLabel">
                            <Autocomplete
                              id="size-small-outlined"
                              size="small"
                              fullWidth
                              disableClearable
                              autoComplete="off"
                              options={this.appUserRoleList}
                              value={this.state.appUserRole}
                              getOptionLabel={(option) => option.name}
                              defaultValue={this.state.appUserRole}
                              onChange={(event, value) => {
                                this.handleUserRoleChange(value);
                              }}
                              inputprops={{
                                style: { textTransform: "capitalize" },
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Please Select"
                                  variant="outlined"
                                  size="small"
                                  className="autoComplete"
                                  style={{ background: "#fff" }}
                                />
                              )}
                            />
                          </div>
                        </div>
                        <div className="row mt-3">
                          <label
                            className="col-sm-4 col-form-label"
                            htmlFor="collapsible-firstname"
                          >
                            Password
                          </label>
                          <div className="col-sm-6" id="assetFormLabel">
                            <div className="input-group input-group-merge">
                              <input
                                title=""
                                type={this.state.showPassword ? "text" : "password"}
                                className="form-control"
                                fullWidth
                                required
                                id="basic-default-password"
                                variant="outlined"
                                name="password"
                                value={this.state.password}
                                onChange={this.handlePasswordChange.bind(this)}
                              />
                              <span
                                className="input-group-text cursor-pointer"
                                id="multiStepsPass2"
                                onClick={this.handleClickShowPassword.bind(this)}
                              >
                                {this.state.showPassword ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <label
                            className="col-sm-4 col-form-label"
                            htmlFor="collapsible-firstname"
                          >
                            Confirm Password
                          </label>
                          <div className="col-sm-6" id="assetFormLabel">
                            <div className="input-group input-group-merge">
                              <input
                                title=""
                                className="form-control"
                                fullWidth
                                required
                                id="confirmPassword"
                                variant="outlined"
                                name="confirmPassword"
                                type={this.state.showConfirmPassword ? "text" : "password"}
                                value={this.state.confirmPassword}
                                onChange={this.handlePasswordConfirmChange.bind(
                                  this
                                )}
                                helperText={
                                  error
                                    ? "Password & confirm password must match"
                                    : ""
                                }
                                error={error}
                              />
                              <span
                                className="input-group-text cursor-pointer"
                                id="multiStepsConfirmPass2"
                                onClick={this.handleClickShowConfirmPassword.bind(
                                  this
                                )}
                              >
                                {this.state.showConfirmPassword ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <label
                            className="col-sm-4 col-form-label"
                            htmlFor="collapsible-firstname"
                          >
                            Mobile No
                          </label>
                          <div className="col-sm-6" id="assetFormLabel">
                            <span className="d-flex">
                              <PhoneInput
                                country="us"
                                value={this.state.countryCode}
                                onChange={(
                                  phone,
                                  country,
                                  e,
                                  formattedValue
                                ) => {
                                  this.handleCountryChange(
                                    phone,
                                    country,
                                    e,
                                    formattedValue
                                  );
                                }}
                                autoFormat
                                countryCodeEditable={false}
                                disableCountryGuess={false}
                                enableSearch={true}
                                alwaysDefaultMask={true}
                              />
                              <input
                                title=""
                                required
                                type="text"
                                autoComplete="off"
                                name="multiStepsFirstName"
                                style={{ borderRadius: "0px 5px 5px 0px" }}
                                className="form-control"
                                value={this.state.phoneNo}
                                onChange={this.handlePhoneChange.bind(this)}
                                validators={["required"]}
                                errormessages={["This field is required"]}
                                onInvalid={(e) => {
                                  e.target.setCustomValidity(
                                    "Mobile number required"
                                  );
                                }}
                              />
                            </span>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <label
                            className="col-sm-4 col-form-label"
                            htmlFor="collapsible-firstname"
                          >
                            User Status
                          </label>
                          <div className="col-sm-6" id="assetFormLabel">
                            <ToggleButton
                              value={
                                this.state.isStatus ? "Active" : "Inactive"
                              }
                              className="ToggleButtonActive"
                              onChange={this.handleStatusChange.bind(this)}
                              style={
                                this.state.isStatus
                                  ? {
                                    background: "#37517e",
                                    color: "#fff",
                                    height: "25px",
                                    width: "70px",
                                    borderRadius: "5px",
                                    textTransform: "none",
                                  }
                                  : {
                                    background: "#D7DBDD",
                                    color: "#000",
                                    height: "25px",
                                    width: "70px",
                                    borderRadius: "5px",
                                    textTransform: "none",
                                  }
                              }
                            >
                              {this.state.isStatus ? "Active" : "Inactive"}
                            </ToggleButton>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-sm-12">
                            <div className="row">
                              <label
                                className="form-label fw-bold"
                                htmlFor="basic-default-name"
                                id="assetFormLabel"
                              >
                                Two-factor Authentication
                                <InfoTooltip
                                  data="This Two-Factor Authentication feature provides you with higher-level of account security by requiring that you enter a unique password after you correctly enter your login ID and password. The unique password is delivered to your mobile phone, by text message, each time you log in.
                            The use of Two-Factor Authentication is recommended."
                                  style={{
                                    float: "right",
                                  }}
                                />
                              </label>
                            </div>
                            <div className="row mt-2">
                              <div className="col-sm-4 d-flex">
                                <label
                                  className="form-label"
                                  htmlFor="multiStepsPass"
                                >
                                  Send verification code to:
                                </label>
                              </div>

                              <div className="col-sm-4">
                                <div className="row">
                                  <div className="col-sm-5 d-flex">
                                    <span
                                      className="me-1"
                                      style={{ marginTop: "2px" }}
                                    >
                                      <input
                                        type="checkbox"
                                        id="sendOtpByText"
                                        style={{ cursor: "pointer" }}
                                        value={this.state.sendOtpByText}
                                        onChange={(e) =>
                                          this.handleSendOtpByTextChange(e)
                                        }
                                        checked={this.state.sendOtpByText}
                                      />
                                    </span>
                                    <label
                                      className="form-label cursor-pointer"
                                      htmlFor="sendOtpByText"
                                    >
                                      SMS
                                    </label>
                                  </div>
                                  <div className="col-sm-5 d-flex">
                                    <span
                                      className="me-1"
                                      style={{ marginTop: "2px" }}
                                    >
                                      <input
                                        type="checkbox"
                                        id="sendOtpByEmail"
                                        style={{ cursor: "pointer" }}
                                        value={this.state.sendOtpByEmail}
                                        onChange={(e) =>
                                          this.handleSendOtpByEmailChange(e)
                                        }
                                        checked={this.state.sendOtpByEmail}
                                      />
                                    </span>
                                    <label
                                      className="form-label cursor-pointer"
                                      htmlFor="sendOtpByEmail"
                                    >
                                      email
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-flex align-items-center justify-content-between">
              <div className="col-sm-12 mt-3 text-center">
                <CreateButton btnName="Create" type="submit" />
                &nbsp;&nbsp;
                <CancelIconButton onClick={(e) => this.createCancel()} />
              </div>
            </div>
          </ValidatorForm >
        </div >
      </>
    );
  }
  viewUser() {
    const { sendOtpByText, sendOtpByEmail } = this.state;

    let contactMethod = "";
    if (sendOtpByText && sendOtpByEmail) contactMethod = "SMS, Email";
    else if (sendOtpByText) contactMethod = "SMS";
    else if (sendOtpByEmail) contactMethod = "Email";

    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <AdminMenuWithBreadScrum
            breadCrumb={this.breadCrumb}
            history={this.props.history}
            name={this.title}
            pageId="User"
            domainObject={this.state.firstName + " " + this.state.lastName}
            backCallback={this.viewCancel.bind(this)}
            editCallback={this.editAppUserDetails.bind(this)}
            deleteCallback={this.deleteAppUserDetails.bind(this)}
            getDeletePermission={this.state.getDeletePermission}
            getUpdatePermission={this.state.getUpdatePermission}
          />
          <div className="row" style={{ padding: "1em", marginTop: "-12px" }}>
            <div className="card" id="organizationFormCard">
              <div className="row">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="row pt-1">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Name
                        </label>
                        <div className="col-sm-8" id="OrganizationCol">
                          <span>
                            {this.state.firstName + " " + this.state.lastName}
                          </span>
                        </div>
                      </div>
                      <div className="row pt-1">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Mobile No
                        </label>
                        <div className="col-sm-8" id="OrganizationCol">
                          <span>{`${this.state.countryCode} ${this.state.phoneNo}`}</span>
                        </div>
                      </div>
                      <div className="row pt-1">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Email
                        </label>
                        <div className="col-sm-8" id="OrganizationCol">
                          <span>{this.state.email}</span>
                        </div>
                      </div>
                      <div className="row pt-1">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Status
                        </label>
                        <div className="col-sm-8" id="OrganizationCol">
                          <span>{this.state.userStatus?.status}</span>
                        </div>
                      </div>
                      <div className="row pt-1">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Profile
                        </label>
                        <div className="col-sm-8" id="OrganizationCol">
                          <span>{this.state.appUserRole?.name}</span>
                        </div>
                      </div>
                      <div className="row pt-1">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Send verification code to
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <span>
                            {contactMethod}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-4 text-center">
              <Button
                type="submit"
                variant="contained"
                size="small"
                style={{
                  background: "#717373",
                  color: "#fff",
                  marginRight: "1rem",
                }}
                startIcon={<ArrowBackIcon />}
                onClick={(e) => this.viewCancel()}
              >
                Back
              </Button>
            </div>
          </div>
        </>
      );
    }
  }
  editUser() {
    return (
      <>
        <AdminMenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          history={this.props.history}
          name={this.title}
        />
        <div className="row">
          <ValidatorForm
            className="text-start"
            ref="form"
            onSubmit={this.updateUserToBackend.bind(this)}
          >
            <div className="row" style={{ marginTop: "1em" }}>
              <div className="col-md-12">
                <div className="card" id="organizationFormCard">
                  <div className="card-body">
                    <div className="row p-2">
                      <div className="col-md-6">
                        <div className="row mt-3">
                          <label
                            className="col-sm-4 col-form-label"
                            htmlFor="collapsible-firstname"
                          >
                            First Name
                          </label>
                          <div className="col-sm-6" id="assetFormLabel">
                            <input
                              title=""
                              required
                              type="text"
                              autoComplete="off"
                              autoFocus={true}
                              id="multiStepsFirstName"
                              name="multiStepsFirstName"
                              className="form-control"
                              value={this.state.firstName}
                              onChange={this.handleFirstNameChange.bind(this)}
                              validators={["required"]}
                              errormessages={["This field is required"]}
                            />
                          </div>
                        </div>
                        <div className="row mt-3">
                          <label
                            className="col-sm-4 col-form-label"
                            htmlFor="collapsible-firstname"
                          >
                            Last Name
                          </label>
                          <div className="col-sm-6" id="assetFormLabel">
                            <input
                              title=""
                              required
                              type="text"
                              autoComplete="off"
                              id="multiStepsFirstName"
                              name="multiStepsFirstName"
                              className="form-control"
                              value={this.state.lastName}
                              onChange={this.handleLastNameChange.bind(this)}
                              validators={["required"]}
                              errormessages={["This field is required"]}
                            />
                          </div>
                        </div>
                        <div className="row mt-3">
                          <label
                            className="col-sm-4 col-form-label"
                            htmlFor="collapsible-firstname"
                          >
                            Email
                          </label>
                          <div className="col-sm-6" id="assetFormLabel">
                            <input
                              title=""
                              required
                              type="email"
                              autoComplete="off"
                              id="multiStepsFirstName"
                              name="multiStepsFirstName"
                              className="form-control"
                              value={this.state.email}
                              onChange={this.handleEmailChange.bind(this)}
                              validators={["required"]}
                              errormessages={[
                                "This field is required",
                                "Email id is not valid",
                              ]}
                            />
                          </div>
                        </div>
                        <div className="row mt-3">
                          <label
                            className="col-sm-4 form-label MuiAutocomplete-label"
                            htmlFor="collapsible-firstname"
                          >
                            Admin User Profile
                            <InfoTooltip
                              data="User Profile are created by Admin Users in Settings"
                              style={{
                                float: "right",
                              }}
                            />
                          </label>
                          <div className="col-sm-6" id="assetFormLabel">
                            <Autocomplete
                              id="size-small-outlined"
                              size="small"
                              fullWidth
                              disableClearable
                              autoComplete="off"
                              options={this.appUserRoleList}
                              value={this.state.appUserRole}
                              getOptionLabel={(option) => option.name}
                              defaultValue={this.state.appUserRole}
                              onChange={(event, value) => {
                                this.handleUserRoleChange(value);
                              }}
                              inputprops={{
                                style: { textTransform: "capitalize" },
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Please Select"
                                  variant="outlined"
                                  size="small"
                                  className="autoComplete"
                                  style={{ background: "#fff" }}
                                />
                              )}
                            />
                          </div>
                        </div>

                        <div className="row mt-3">
                          <label
                            className="col-sm-4 col-form-label"
                            htmlFor="collapsible-firstname"
                          >
                            Mobile No
                          </label>
                          <div className="col-sm-6" id="assetFormLabel">
                            <span className="d-flex">
                              <PhoneInput
                                country="us"
                                value={this.state.countryCode}
                                onChange={(
                                  phone,
                                  country,
                                  e,
                                  formattedValue
                                ) => {
                                  this.handleCountryChange(
                                    phone,
                                    country,
                                    e,
                                    formattedValue
                                  );
                                }}
                                autoFormat
                                countryCodeEditable={false}
                                disableCountryGuess={false}
                                enableSearch={true}
                                alwaysDefaultMask={true}
                              />
                              <input
                                title=""
                                required
                                type="text"
                                autoComplete="off"
                                name="multiStepsFirstName"
                                style={{ borderRadius: "0px 5px 5px 0px" }}
                                className="form-control"
                                value={this.state.phoneNo}
                                onChange={this.handlePhoneChange.bind(this)}
                                validators={["required"]}
                                errormessages={["This field is required"]}
                                onInvalid={(e) => {
                                  e.target.setCustomValidity(
                                    "Mobile number required"
                                  );
                                }}
                              />
                            </span>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <label
                            className="col-sm-4 col-form-label"
                            htmlFor="collapsible-firstname"
                          >
                            User Status
                          </label>
                          <div className="col-sm-6" id="assetFormLabel">
                            <ToggleButton
                              value={
                                this.state.isStatus ? "Active" : "Inactive"
                              }
                              className="ToggleButtonActive"
                              onChange={this.handleStatusChange.bind(this)}
                              style={
                                this.state.isStatus
                                  ? {
                                    background: "#37517e",
                                    color: "#fff",
                                    height: "25px",
                                    width: "70px",
                                    borderRadius: "5px",
                                    textTransform: "none",
                                  }
                                  : {
                                    background: "#D7DBDD",
                                    color: "#000",
                                    height: "25px",
                                    width: "70px",
                                    borderRadius: "5px",
                                    textTransform: "none",
                                  }
                              }
                            >
                              {this.state.isStatus ? "Active" : "Inactive"}
                            </ToggleButton>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-sm-12">
                            <div className="row">
                              <label
                                className="form-label fw-bold"
                                htmlFor="basic-default-name"
                                id="assetFormLabel"
                              >
                                Two-factor Authentication
                                <InfoTooltip
                                  data="This Two-Factor Authentication feature provides you with higher-level of account security by requiring that you enter a unique password after you correctly enter your login ID and password. The unique password is delivered to your mobile phone, by text message, each time you log in.
                            The use of Two-Factor Authentication is recommended."
                                  style={{
                                    float: "right",
                                  }}
                                />
                              </label>
                            </div>
                            <div className="row mt-2">
                              <div className="col-sm-4 d-flex">
                                <label
                                  className="form-label"
                                  htmlFor="multiStepsPass"
                                >
                                  Send verification code to:
                                </label>
                              </div>

                              <div className="col-sm-4">
                                <div className="row">
                                  <div className="col-sm-5 d-flex">
                                    <span
                                      className="me-1"
                                      style={{ marginTop: "2px" }}
                                    >
                                      <input
                                        type="checkbox"
                                        id="sendOtpByText"
                                        style={{ cursor: "pointer" }}
                                        value={this.state.sendOtpByText}
                                        onChange={(e) =>
                                          this.handleSendOtpByTextChange(e)
                                        }
                                        checked={this.state.sendOtpByText}
                                      />
                                    </span>
                                    <label
                                      className="form-label cursor-pointer"
                                      htmlFor="sendOtpByText"
                                    >
                                      SMS
                                    </label>
                                  </div>
                                  <div className="col-sm-5 d-flex">
                                    <span
                                      className="me-1"
                                      style={{ marginTop: "2px" }}
                                    >
                                      <input
                                        type="checkbox"
                                        id="sendOtpByEmail"
                                        style={{ cursor: "pointer" }}
                                        value={this.state.sendOtpByEmail}
                                        onChange={(e) =>
                                          this.handleSendOtpByEmailChange(e)
                                        }
                                        checked={this.state.sendOtpByEmail}
                                      />
                                    </span>
                                    <label
                                      className="form-label cursor-pointer"
                                      htmlFor="sendOtpByEmail"
                                    >
                                      email
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-flex align-items-center justify-content-between">
              <div className="col-sm-12 mt-3 text-center">
                <SaveButton id="saveButton" type="submit">
                  {" "}
                  Save{" "}
                </SaveButton>
                &nbsp;&nbsp;
                <CancelIconButton onClick={(e) => this.editCancel()} />
              </div>
            </div>
          </ValidatorForm>
        </div>
      </>
    );
  }
}
export default withRouter(AdminAppUser);
